import React from 'react';

import { PaddingModes } from '@wix/wix-ui-tpa';

import { useLinkHandler } from 'AiAssistantWidget/hooks';

import {
  WidgetButton,
  WidgetButtonPriority,
  WidgetButtonSize,
} from './WidgetButton';
import { st, classes } from './WidgetButton.st.css';

export const LinkButton: React.FC<{
  title: string;
  link: string;
  reportNavigationToAssistant?: {
    id: string;
  };
  priority?: WidgetButtonPriority;
  fullWidth?: boolean;
  size?: WidgetButtonSize;
  paddingMode?: PaddingModes;
  id?: string;
  ariaLabelledBy?: string;
}> = ({
  title,
  link,
  reportNavigationToAssistant,
  priority = WidgetButtonPriority.primary,
  fullWidth = false,
  size = WidgetButtonSize.medium,
  paddingMode,
  id,
  ariaLabelledBy,
}) => {
  const { handleLinkClick, isOwn } = useLinkHandler(
    link,
    reportNavigationToAssistant,
  );
  return isOwn ? (
    <WidgetButton
      id={id}
      ariaLabelledBy={ariaLabelledBy}
      text={title}
      onClick={handleLinkClick}
      priority={priority}
      fullWidth={fullWidth}
      size={size}
      paddingMode={paddingMode}
    />
  ) : (
    <a
      id={id}
      aria-labelledby={ariaLabelledBy}
      className={st(classes.root, { fullWidth, priority, size }, classes.link)}
      href={link}
      target="_blank"
      rel="noreferrer"
    >
      {title}
    </a>
  );
};
